module.exports = __webpack_public_path__ + "img/blueqizi.226da80f.png";